import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalVars } from '../../../../providers/globalVars';
import { AngularFireDatabase,AngularFireList } from '@angular/fire/database';
import * as firebase from 'firebase/app';
import { IonRouterOutlet,ToastController,ModalController,IonContent } from '@ionic/angular';

import { Storage } from '@ionic/storage';
import { FirstvisitmodalPage } from '../../../support/firstvisitmodal/firstvisitmodal.page';

@Component({
  selector: 'app-pointmain',
  templateUrl: './pointmain.page.html',
  styleUrls: ['./pointmain.page.scss'],
})
export class PointmainPage implements OnInit {
  @ViewChild(IonContent) content: IonContent;
  pageenter: any = false;
  ltdropdown:boolean = false;
  slideOpts = {
    initialSlide: 0,
    speed: 500,
    slidesPerView: 2,
    slidesPerColumn: 2,
    slidesPerGroup: 2,
    spaceBetween: 16,
    // autoplay: {
    //   delay: 2500,
    //   disableOnInteraction: true
    // }
  }

  waitinglist:any;
  pitemlist:any[] = [];
  pointadvlist:any[] = [];
  Arr = Array;
  totalpitems:any[] = [];

  nowtime:any = new Date().getTime();
  loaddone:boolean = false;
  nodata:boolean = false;

  loadedPitem = true;

  @ViewChild('citybox') citybox;
  @ViewChild('cityboxInner') cityboxInner;
  thisfile = 'pointmain';

  currentloclan:any;
  appitemlist:any[] = [];
  lotteryState;

  constructor(public gv: GlobalVars,private outlet:IonRouterOutlet,private toastCtrl:ToastController,public storage: Storage,public modalCtrl: ModalController,
    private afDB: AngularFireDatabase) { }

  ngOnInit() {
    this.gv.getRegion(); //열려있는 지역(도시)값 불러옴
    this.outlet.swipeGesture = false;
    // this.loaddata()
    this.afDB.object('/event/AlltimeLottery/isOpened/').snapshotChanges().subscribe(val=>{
      this.lotteryState = val.payload.val();//.$value;
    });;
  }

  ionViewDidEnter(){
    this.gv.selectedcontent = this.content;
    if(this.currentloclan != this.gv.loc + '_' + this.gv.lan)
      this.loaddata();
  }

  loaddata(){
    this.currentloclan = this.gv.loc + '_' + this.gv.lan;
    if(this.gv.loc && this.gv.lan)
      this.doRefresh();
    else
      {setTimeout(_=>{this.currentloclan = this.gv.loc + '_' + this.gv.lan; this.doRefresh()},5000)}
  }
  ionViewWillLeave(){this.gv.selectedcontent = null;}
  ionViewDidLeave(){
    this.outlet.swipeGesture = true;
  }

  slidesOption(listLength){
    let slOpts = {
      initialSlide: 0,
      speed: 500,
      slidesPerView: 2,
      slidesPerColumn: listLength <= 2 ? 1 : 2,
      slidesPerGroup: 2,
      spaceBetween: 16
    };
    // if( listLength <= 2 ) {
    //   this.slideOpts.slidesPerColumn = 1;
    // } else {
    //   this.slideOpts.slidesPerColumn = 2;
    // }
    return slOpts;
  }

  doRefresh(refresh?) {
    this.pageenter = false;
    this.getdata();
    setTimeout(_=>{
      if(refresh) {
        refresh.target.complete();
      }
      this.pageenter = true;
    },500);
  } 

  getpagenum(item){
    return Math.ceil(item.length / 4);
  }

  getdata(){
    if(this.gv.admin)
    this.getwaitinglist()
    
    this.getpmdata();
    this.getadvdata();
    this.getappitemdata();
  }

  getwaitinglist(){
    this.waitinglist = [];
    firebase.database().ref("/pmall")
    .orderByChild("state").equalTo("waiting")
    .once('value').then(rst=>{
      rst.forEach(r=>{
        let data = r.val();
        this.waitinglist.push({key:r.key, 
          type:data.type,
          img:data.imagethumb,
          loc:data.loc,
          title:data.title,
          createdDate:data.createdDate,
          point:data.point,
          state:data.state
        });
      })
    })
    firebase.database().ref("/pmall")
    .orderByChild("state").equalTo("hide")
    .once('value').then(rst=>{
      rst.forEach(r=>{
        let data = r.val();
        this.waitinglist.push({key:r.key, 
          type:data.type,
          img:data.imagethumb,
          loc:data.loc,
          title:data.title,
          createdDate:data.createdDate,
          point:data.point,
          state:data.state
        });
      })
    })
  }
  sltcity(city){
    if(this.gv.uid){
      firebase.database().ref('/userProfile/' + this.gv.uid + '/loc').set(city);
    }
    this.gv.setlocinlocal(city)
    this.gv.loc = city;
    // this.ltdropdown = false; 
    this.cityboxOff();
    this.getdata();
    
    //this.refreshdata()
  }

  cityboxToggle() {
    if( this.ltdropdown == false ) {
      this.cityboxOn();
    } else {
      this.cityboxOff();
    }
  }
  cityboxOn() {
    this.citybox.nativeElement.style.display = 'block';
    this.cityboxInner.nativeElement.scrollLeft = 0;
    setTimeout(_=>{
      this.ltdropdown = true;
    },50);
  }
  cityboxOff() {
    this.ltdropdown = false;
    setTimeout(_=> {
      this.citybox.nativeElement.style.display = 'none';
      this.ltdropdown = false;
    }, 300);
  }

  getpmdata()
  {
    firebase.database().ref("/pmall").orderByChild("loc").equalTo(this.gv.loc)
    .once('value').then(rst=>{
      this.pitemlist = [];
      rst.forEach(r=>{
        let data = r.val();
        if((!data.eventend || data.eventend > this.nowtime) && data.state == 'confirm')
        {
        this.pitemlist.push({key:r.key, 
          type:data.type,
          img:data.imagethumb,
          loc:data.loc,
          title:data.title,
          createdDate:data.createdDate,
          point:data.point,
          state:data.state,
          order:data.order?data.order:0,
          hot:(this.nowtime - data.createdDate)/1000/60/60/24 <= 30?'hot':'old'
        });
        }
        // console.log(this.pitemlist);
      })
      // this.loaddone = true;
    }).then(_=>{
      this.loaddone = true;
      if(this.gv.needfillfav) { // 리, 비회원이 지역값 없을때 최초 1회만 노출 되어야 합니다.
          this.firstvisitModal();
        }
      else
      {
        this.storage.get('savedaccloc').then(rst=>{
          if(!rst && !this.gv.loc)
            this.firstvisitModal();
        })
      }
    })
  }

  async firstvisitModal() {
    const modal = await this.modalCtrl.create({
      component: FirstvisitmodalPage,
      cssClass: 'ph-custom-modal',
      backdropDismiss: false,
      componentProps: < null > {p:this}
      // componentProps: < null > {
      //   list: list,
      //   index: index
      // }
    });
    //modal.onDidDismiss().then(_=>{
    //  this.refreshdata();
    //})
    return await modal.present();
  }

  getadvdata()
  {
    firebase.database().ref("/pmall").orderByChild("type").equalTo("adv")
    .once('value').then(rst=>{
      this.pointadvlist = [];
      rst.forEach(r=>{
        let data = r.val();
        if(data.state == 'confirm')
        this.pointadvlist.push({key:r.key, 
          type:data.type,
          img:data.imagethumb,
          loc:data.loc,
          title:data.title,
          createdDate:data.createdDate,
          point:data.point,
          state:data.state,
          order:data.order?data.order:0
        });
        // console.log(this.pointadvlist);
      })
    })
  }
  
  getappitemdata() {
    let colorarr = ['bluebg', 'graybg', 'lightgreenbg', 'orangebg'];
    let idx = 0;
    firebase.database().ref("/pmall").orderByChild("type").equalTo("appitem")
    .once('value').then(rst=>{
      this.appitemlist = [];
      rst.forEach(r=>{
        let data = r.val();
        if(data.state == 'confirm')
        this.appitemlist.push({key:r.key, 
          type:data.type,
          img:data.imagethumb,
          loc:data.loc,
          title:data.title,
          createdDate:data.createdDate,
          point:data.point,
          state:data.state,
          order:data.order?data.order:0,
          bgcolor: colorarr[idx]
        });
        idx++;
        if( idx >= rst.val().length ) idx = 0;
        // console.log(this.appitemlist);
      })
    })
  }

  commingsoon(){
    this.presentToast('준비중인 항목입니다.');
  }
    async presentToast(message: string) {
    let toast = await this.toastCtrl.create({
    message: message,
    position: 'bottom',
    duration: 2500
    });
    toast.present();
    }

    
}
